import { lazy } from 'react';

/** Markdown rendering (react-markdown, micromark) and the brief font load only with the brief itself. */
export const LazyBriefDocument = lazy(() => import('./BriefView.js').then((m) => ({ default: m.BriefDocument })));
export const LazyBriefSections = lazy(() => import('./BriefView.js').then((m) => ({ default: m.BriefSections })));
